import { h, Component } from "preact";
import { css } from "emotion";
import iconSuccess from "../../../assets/images/icon-success.svg";
import iconDown from "../../../assets/images/icon-down.svg";

class MultipleOptions extends Component {
  constructor() {
    super();
    this.state = {
      dropDownClicked: false
    };
  }
  selectedOptionsClick = id => {
    const { options, optionClicked } = this.props;
    let filteredToasts = options.slice();

    filteredToasts.map(obj => {
      if (obj.id === id) {
        obj.value = false;
      }
    });
    this.setState({ dropDownClicked: false });
    optionClicked(filteredToasts);
  };
  optionsOnChange = (index, value) => {
    const { options, selectedBadgeClicked } = this.props;
    let optionsCopy = options.slice();
    optionsCopy[index].value = value;
    selectedBadgeClicked(optionsCopy);
  };
  openOptions = () => {
    const { dropDownClicked } = this.state;
    this.setState({ dropDownClicked: !dropDownClicked });
  };
  render() {
    const { options, touched, error, trackQuantity, disabled } = this.props;
    const { dropDownClicked } = this.state;
    let selected = [];
    options.map(day => {
      if (day.value) {
        selected.push({ label: day.label, id: day.id });
      }
    });

    const styles = {
      selectedOptionsBadges: css`
        text-transform: capitalize;
        font-size: 14px;
        border-radius: 2px;
        padding: 0 10px 0 10px;
        margin: 0 4px 4px 0;
        border: solid 1px #ddd;
        display: inline-block;
        background: hsl(0, 0%, 98%);
        cursor: pointer;
        &:after {
          content: "×";
          cursor: pointer;
          margin-left: 5px;
          vertical-align: middle;
          color: rgba(0, 0, 0, 0.45);
        }
        &:hover {
          background: hsl(0, 0%, 88%);
        }
      `,
      optionList: css`
        cursor: default;
        margin-bottom: 2px;
        text-transform: capitalize;
        padding: 2px 15px 2px 5px;
      `,
      optionListSelect: css`
        cursor: default;
        text-transform: capitalize;
        padding: 2px 15px 2px 5px;
        background: #fafafa;
        position: relative;
        font-weight: 600;
        margin: 2px;
      `,
      optionListDisable: css`
        pointer-events: none;
        opacity: 0.5;
        cursor: default;
        margin-bottom: 2px;
        text-transform: capitalize;
        padding: 2px 15px 2px 5px;
      `,
      arrow: css`
        margin: auto;
        display: inline-block;
        cursor: pointer;
        font-size: 12px;
        width: 20px;
        display: inline-block;
        cursor: pointer;
      `,
      optionListSelectIcon: css`
        position: absolute;
        right: 0px;
        top: 4px;
      `,
      selectedOptionsBadgesList: css`
        font-weight: 400;
        text-align: left;
        vertical-align: middle;
        display: inline-block;
        width: calc(100% - 40px);
        white-space: wrap;
        text-overflow: clip;
        overflow: hidden;
      `,
      selectedOptions: css`
        vertical-align: middle;
        height: inherit;

        border-radius: 4px;
        display: inline-block;
        padding: 5px 0px 5px 10px;
        width: inherit;
      `,
      options: css`
                z-index: 10001;
                overflow-x: auto;
                background-color: #fff;
                position: absolute;
                margin: 0;
                border: 0.05rem solid #e7e7e7;
                border-radius: 4px;
                //border-top-width: 0;
                // border-top-left-radius: 0;
                //border-top-right-radius: 0;
                width: 100%;
                padding: 0;
                display: ${dropDownClicked ? "block" : "none"};
                color: #323232,
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15;
            `,
      list: css`
        position: relative;
        display: block;
        font-size: 16;
        margin-top: 0;
        margin-bottom: 0;
      `
    };

    let selectedList = (
      <label class={styles.selectedOptionsBadgesList}>
        {selected.map(obj => {
          return (
            <span
              key={obj.id}
              onClick={() => this.selectedOptionsClick(obj.id)}
              class={styles.selectedOptionsBadges}
            >
              {obj.label}
            </span>
          );
        })}
      </label>
    );
    return (
      <div
        class="multiple-options-input"
        tabIndex="0"
        onBlur={() => {
          this.setState({ dropDownClicked: false });
        }}
        disabled={disabled}
        error={touched && error ? true : false}
      >
        <div class={styles.selectedOptions} onClick={this.openOptions}>
          {selectedList}
          <div class={styles.arrow}>
            <img src={iconDown} class={styles.optionListSelectIcon} />
          </div>
        </div>
        <ul class={styles.options}>
          {options.map((option, index) => {
            let liClass = option.value
              ? styles.optionListSelect
              : styles.optionList;
            const quantityLeft =
              option.hasOwnProperty("quantityLeft") === true
                ? option.quantityLeft
                : 1000000;
            const disabled = quantityLeft > 0 ? false : true;
            liClass = disabled ? styles.optionListDisable : liClass;
            const onClick = disabled
              ? null
              : () => this.optionsOnChange(index, !option.value);
            return (
              <li
                class={styles.list}
                key={option.id}
                value={option.value}
                disabled={disabled}
              >
                <div class={liClass} onClick={onClick}>
                  {option.label}{" "}
                  {quantityLeft > 0 && quantityLeft < 11 && (
                    <span>({quantityLeft} available)</span>
                  )}
                  {trackQuantity && disabled && <span>(Not available)</span>}
                  {option.value ? (
                    <img
                      src={iconSuccess}
                      class={styles.optionListSelectIcon}
                    />
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default MultipleOptions;



// WEBPACK FOOTER //
// ./components/fields/multipleOptions/MultipleOptions.js